import { Typography } from '@mui/material';

type EmptyStateMessageProps = {
  message: string;
  centered?: boolean;
};

export const EmptyStateMessage: React.FC<EmptyStateMessageProps> = ({
  message,
  centered = false,
}) => {
  return (
    <Typography
      variant="body2"
      sx={{
        color: 'text.secondary',
        pt: 2,
        pb: centered ? 3 : 2,
        fontStyle: 'italic',
        display: 'block',
        width: '100%',
        textAlign: centered ? 'center' : 'left',
      }}
    >
      {message}
    </Typography>
  );
};
